import GenerateSlug from '@/plugin/generateSlug'
import { slugToId } from '../url'

export default class InsightsRoute extends GenerateSlug<{
  category: string
  search: string
  tag: string
  page: number
}> {
  constructor() {
    super({
      category: '',
      search: '',
      tag: '',
      page: 1,
    })
  }

  toQuery() {
    let tag = this.getVal('tag')
    let category = this.getVal('category')
    const page = this.getVal('page')
    if (tag) {
      tag = String(slugToId(tag))
    }
    if (category) {
      category = String(slugToId(category))
    }
    return {
      category,
      search: this.getVal('search'),
      tag,
      page,
    }
  }
}
